import { useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import i18n, { setAppLanguage } from "./index";
import { normalizeLang, langMeta } from "./languages";

export default function LocaleProvider({ lng = "en", children }) {
  const code = normalizeLang(lng);
  useEffect(() => {
    setAppLanguage(code);
  }, [code]);
  const dir = langMeta(code).dir || "ltr";
  return (
    <I18nextProvider i18n={i18n}>
      <div dir={dir} lang={code} className="contents">
        {children}
      </div>
    </I18nextProvider>
  );
}
